// Widget for the filter form
import $ from 'jquery';
import Dropdown from './dropdown';
import LocationSelect from './location-select';
import ToggleSelect from './toggle-select';

const FILTER_CLOSE_SELECTOR = '.property-list-filters-close .btn';
const RESET_FILTERS_SELECTOR = '.reset-filter-form';
const SHOW_MORE_FILTERS_SELECTOR = '.show-more-filters';
const SHOW_MORE_FILTERS_LINK_SELECTOR = '.show-more-filters-link';
const SHOW_MORE_FILTERS_CONTAINER_SELECTOR = '.show-more-filters-container';

export default class PropertyListFilterForm {
  constructor( element ) {
    this.element = element;
    this.children = [];
    this.initialize();
  }

  initialize() {
    this.addEventHandlers();
    this.initializeFormWidgets();
  }

  /**
   * Initializes custom widgets inside the filter form
   */
  initializeFormWidgets() {
    // Initialize custom dropdown selects
    this.element.find('select').each((index, select) => {
      if (!select.multiple) {
        this.children.push(new Dropdown(select));
      }
    });
    // Initialize custom toggle selects
    this.element.find('.transaction-type-switch').each((index, toggle) => {
      this.children.push(new ToggleSelect(toggle));
    });
    // Initialize custom zone selects
    this.element.find('.location-select').each((index, widget) => {
      this.children.push(new LocationSelect(widget, true));
    });
  }

  resetForm() {
    // Reset custom widgets, instantiated above
    for (var i = this.children.length - 1; i >= 0; i--) {
      this.children[i].reset();
    }
    // Reset checkbox buttons (btn-group-toggle), used for rooms
    this.element.find('.btn-group-toggle label').removeClass('active');
    this.element.find('.btn-group-toggle input').attr('checked', false);
    // Reset all other inputs
    this.element.find(':input')
                .not(':button, :submit, :reset, :hidden')
                .val('')
                .prop('checked', false)
                .prop('selected', false);
  }

  showMoreFilters() {
    this.element.find(SHOW_MORE_FILTERS_CONTAINER_SELECTOR).removeClass('d-none');
    this.element.find(SHOW_MORE_FILTERS_LINK_SELECTOR).addClass('d-none').removeClass('d-block');
  }

  addEventHandlers() {
    // Filter properties on submit
    this.element.find('.btn-filter-properties').on('click', (event) => {
      this.element.collapse('hide');
    });

    // Hide filters panel handle
    this.element.find(FILTER_CLOSE_SELECTOR).on('click', (event) => {
      event.preventDefault();
      this.element.collapse('hide');
    });

    // Show more filters
    this.element.find(SHOW_MORE_FILTERS_SELECTOR).on('click', (event) => {
      event.preventDefault();
      this.showMoreFilters();
    });

    // Reset filters
    this.element.find(RESET_FILTERS_SELECTOR).on('click', (event) => {
      event.preventDefault();
      this.resetForm();
    });
  }
}
